import * as React from 'react';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { CommonActions } from '@react-navigation/native';

import HomeStatusBar from '../../components/HomeStatusBar';
import HomeTabs from 'src/components/HomeTabs';
import CudaRuntimeBanner from 'src/components/CudaRuntimeBanner';
import * as JobActions from '../../redux/actions/jobAction';
import { IStore } from '../../redux/reducers';

export default function HomePage({ navigation, route }) {
    const dispatch = useDispatch();
    const currentJobId = useSelector((store: IStore) => store.job.jobId);

    // Load job from URL query param when component mounts or route changes
    useEffect(() => {
        const jobIdFromRoute = route?.params?.jobId;
        if (jobIdFromRoute && jobIdFromRoute !== currentJobId) {
            dispatch(JobActions.setJobId(jobIdFromRoute));
            dispatch(JobActions.pollJobStatus.request(jobIdFromRoute));
        }
    }, [route?.params?.jobId, dispatch]);

    // Update URL when jobId changes in Redux (e.g., when new job is created)
    useEffect(() => {
        const jobIdFromRoute = route?.params?.jobId;
        if (currentJobId && currentJobId !== jobIdFromRoute) {
            navigation.dispatch(
                CommonActions.setParams({
                    jobId: currentJobId
                })
            );
        }
    }, [currentJobId, route?.params?.jobId, navigation]);

    return <>
        <HomeStatusBar />
        <CudaRuntimeBanner />
        <HomeTabs navigation={navigation} route={route} />
    </>;
}
